import { render, staticRenderFns } from "./CreatePayroll.vue?vue&type=template&id=32e82d52"
import script from "./CreatePayroll.vue?vue&type=script&lang=js"
export * from "./CreatePayroll.vue?vue&type=script&lang=js"
import style0 from "./CreatePayroll.vue?vue&type=style&index=0&id=32e82d52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports